<!--三个记录通用的复制弹窗-->
<template>

  <el-dialog title="修改备注" :visible.sync="delDialogVisible" width="480px" @close="closedelDialog">
    <div>
      <el-input type="textarea" :rows="3" maxlength="30" show-word-limit placeholder="请输入备注" v-model="remark">
      </el-input>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="" size="small" @click="closedelDialog">取消</el-button>

      <el-button type="primary" size="small" @click="confirmTheChanges">确认</el-button>

    </span>
  </el-dialog>

</template>
<script>
export default {
  components: {},
  props:{
    delDialogVisible:{
      type:Boolean,
      default:false
    },
    userRemark:{
      type:String,
      default:""
    },
    id:{
      type:String,
      default:""
    },

  },
  data() {
    return {
      remark:''
    }
  },
  created(){
    this.remark = this.userRemark;
  },
  mounted() {
    
  },
  methods: {

    closedelDialog(){
      this.$emit("closedelDialog")
    },
    confirmTheChanges(){
      this.$emit("confirmTheChanges",this.remark)
    }
  }
}
</script>
<style lang="less" scoped>
.orderNumber {
  background: #f2f3f5;
  border-radius: 4px;
  padding: 6px 16px;
  margin: 0 16px 16px 0;
  width: fit-content;
}
.form-part {
  height: 36px;
  background: linear-gradient(90deg, #eaf4fe 0%, rgba(198, 225, 253, 0) 100%);
  border-radius: 4px;
  line-height: 36px;
  padding-left: 24px;
  margin: 0 0 16px 0;
  color: #333333;
}
</style>